import React, { useState } from 'react';

const faqs = [
  {
    question: 'Wat is een NDA voor ZZP\'ers?',
    answer: 'Een NDA (Non-Disclosure Agreement) of geheimhoudingsverklaring is een juridisch bindend contract waarbij partijen afspreken om vertrouwelijke informatie niet te delen met derden. Voor Nederlandse ZZP\'ers en freelancers is een NDA essentieel wanneer je werkt met gevoelige bedrijfsinformatie van opdrachtgevers. In Nederland wordt de bescherming van bedrijfsgeheimen geregeld door de Wet bescherming bedrijfsgeheimen (Wbb) van 2018.',
  },
  {
    question: 'Wanneer heb je als ZZP\'er een NDA nodig?',
    answer: 'Als Nederlandse ZZP\'er of freelancer heb je een NDA nodig wanneer je toegang krijgt tot vertrouwelijke informatie van een opdrachtgever, zoals bedrijfsstrategieën, klantgegevens, broncode, financiële gegevens of productideeën. Veel Nederlandse bedrijven eisen een ondertekende NDA voordat ze met een externe ZZP\'er samenwerken. Ook bij het pitchen van eigen concepten aan potentiële klanten is een NDA verstandig.',
  },
  {
    question: 'Hoe lang is een NDA geldig in Nederland?',
    answer: 'De geldigheidsduur van een NDA in Nederland wordt bepaald door de partijen zelf en staat vermeld in het contract. Typisch varieert de duur van 2 tot 5 jaar na beëindiging van de opdracht. Voor informatie die kwalificeert als bedrijfsgeheim conform de Wet bescherming bedrijfsgeheimen kan de geheimhoudingsplicht onbeperkt gelden zolang de informatie haar vertrouwelijk karakter behoudt.',
  },
  {
    question: 'Wat staat er in een goede NDA voor Nederlandse freelancers?',
    answer: 'Een goede NDA voor Nederlandse ZZP\'ers bevat: een duidelijke definitie van vertrouwelijke informatie conform de Wbb, de geheimhoudingsverplichtingen van de ontvanger, uitzonderingen op de geheimhoudingsplicht, de duur van de geheimhouding, een boetebeding bij schending, de verplichting tot teruggave van documenten, en het toepasselijk Nederlands recht met de bevoegde rechtbank. Identificatie via KvK-nummer en btw-nummer zorgt voor correcte partijidentificatie.',
  },
  {
    question: 'Is een NDA afdwingbaar in Nederland?',
    answer: 'Ja, een correct opgestelde en ondertekende NDA is juridisch afdwingbaar in Nederland. Bij schending kan de benadeelde partij schadevergoeding eisen op grond van artikel 6:74 BW en een rechterlijk verbod aanvragen. Een boetebeding maakt handhaving eenvoudiger doordat de boete direct opeisbaar is zonder dat bewijs van schade nodig is. De Wet bescherming bedrijfsgeheimen biedt aanvullende bescherming voor kwalificerende bedrijfsgeheimen.',
  },
];

const FaqItem = ({ faq }) => {
  const [open, setOpen] = useState(false);
  return (
    <div className="border border-gray-200 rounded-xl bg-white shadow-sm overflow-hidden">
      <button
        onClick={() => setOpen(!open)}
        className="w-full flex items-center justify-between px-6 py-5 text-left focus:outline-none"
        aria-expanded={open}
      >
        <span className="text-base font-semibold text-[#2F4E6F] pr-4">{faq?.question}</span>
        <span
          className="flex-shrink-0 w-6 h-6 rounded-full flex items-center justify-center transition-transform duration-200"
          style={{ backgroundColor: '#FF8C00', transform: open ? 'rotate(45deg)' : 'rotate(0deg)' }}
        >
          <svg className="w-3 h-3 text-white" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={3} d="M12 4v16m8-8H4" />
          </svg>
        </span>
      </button>
      {open && (
        <div className="px-6 pb-5">
          <p className="text-gray-600 leading-relaxed">{faq?.answer}</p>
        </div>
      )}
    </div>
  );
};

const NdaNetherlandsFaq = () => (
  <section className="mb-12">
    <h2 className="text-2xl font-bold text-[#2F4E6F] mb-6">Veelgestelde vragen over NDA's voor ZZP'ers in Nederland</h2>
    <div className="space-y-4">
      {faqs?.map((faq, i) => (
        <FaqItem key={i} faq={faq} />
      ))}
    </div>
  </section>
);

export default NdaNetherlandsFaq;
export { faqs };
